import { render, staticRenderFns } from "./CustomerSupport.vue?vue&type=template&id=d2374502&scoped=true"
import script from "./CustomerSupport.vue?vue&type=script&lang=js"
export * from "./CustomerSupport.vue?vue&type=script&lang=js"
import style0 from "./CustomerSupport.vue?vue&type=style&index=0&id=d2374502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2374502",
  null
  
)

export default component.exports